import type { CSSProperties } from 'react';

export const defermentFieldsContainerSx = {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 2,
    paddingTop: 2,
    alignItems: 'flex-start'
};

export const defermentFooterActionsContainerSx = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    paddingTop: 2
};

export const defermentTrashIconContainerSx = {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2.5rem'
};

export const defermentTrashIconStyles: CSSProperties = {
    cursor: 'pointer',
    opacity: 1
};
